import React, { useCallback, useState } from "react";
import styled from "styled-components";

import { JS } from "../constants";
import { useEmbedParametersContext } from "../contexts/embedParametersContext";
import * as cloudinary from "../helpers/cloudinary";
import { usePrevious } from "../helpers/commonUtils";
import i18n from "../service/i18n";
import { usePlayerStore } from "../store/usePlayerStore";

const Img = styled.img`
  display: block;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute;
  top: 0;
  transition: opacity 0.2s ease-in-out;
  width: 100%;
`;

export const PreviewImage = () => {
  const { useStoreState } = usePlayerStore();
  const aspectRatio = useStoreState.aspectRatio();
  const mediaData = useStoreState.media();

  const { language } = useEmbedParametersContext();

  const [imageSrc, setImageSrc] = useState<string>(
    mediaData
      ? cloudinary.imageUrl({
          aspectRatio,
          format: "jpg",
          id: mediaData?.image.id,
          serviceId: mediaData?.serviceId,
          version: mediaData?.image.version
        })
      : ""
  );
  const [scaledImageSrc, setScaledImageSrc] = useState<string>("");
  const previousImageId = usePrevious(mediaData?.image.id);
  const previousAspectRatio = usePrevious(aspectRatio);
  const [opacityValue, setOpacityValue] = useState(0);

  const imgContainer = useCallback(
    async node => {
      if (
        mediaData &&
        (previousImageId !== mediaData.image.id ||
          previousAspectRatio !== aspectRatio)
      ) {
        setImageSrc(
          cloudinary.imageUrl({
            aspectRatio: aspectRatio,
            format: "jpg",
            id: mediaData.image.id,
            serviceId: mediaData.serviceId,
            version: mediaData.image.version
          })
        );
        setScaledImageSrc("");
        setOpacityValue(0);
      }

      if (node !== null) {
        const scaledImg = await cloudinary.scaledUrl(node, imageSrc);

        if (scaledImageSrc !== scaledImg) {
          setOpacityValue(0);
          setScaledImageSrc(scaledImg);
        }
      }
    },
    [
      previousImageId,
      previousAspectRatio,
      aspectRatio,
      imageSrc,
      scaledImageSrc,
      mediaData
    ]
  );

  return (
    <Img
      aria-hidden={true}
      alt={i18n("preview_image", { language })}
      className={JS.IMAGE_CLASS}
      src={scaledImageSrc}
      ref={imgContainer}
      style={{ opacity: opacityValue }}
      onLoad={() => {
        setOpacityValue(1);
      }}
    />
  );
};
